
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bliv-medlem",
      function () {
        return require("private-next-pages/bliv-medlem/index.route.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bliv-medlem"])
      });
    }
  